module.exports = __webpack_public_path__ + "img/scadenze-emt.c7d8d2bd.png";